import React from "react";
import { Link } from "react-router-dom";
import useScrollReveal from "../hooks/useScrollReveal";
import "./FinalCTA.css";

export default function FinalCTA() {
  const sectionRef = useScrollReveal(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".final-cta__title span"), {
      y: 30,
      opacity: 0,
      duration: 0.8,
      stagger: 0.08,
      ease: "power3.out",
      scrollTrigger: { trigger: el, start: "top 80%" },
    });
    gsap.from(el.querySelectorAll(".final-cta__content p, .final-cta__buttons"), {
      y: 20,
      opacity: 0,
      duration: 0.7,
      stagger: 0.1,
      delay: 0.2,
      ease: "power3.out",
      scrollTrigger: { trigger: el, start: "top 80%" },
    });
  }, []);

  return (
    <section className="final-cta" ref={sectionRef}>
      <div className="final-cta__disc" aria-hidden="true" />
      <div className="container final-cta__content">
        <h2 className="final-cta__title">
          <span>READY TO</span>
          <span className="accent-text">SWITCH ON?</span>
        </h2>
        <p>Let&rsquo;s build a smarter energy future together.</p>
        <div className="final-cta__buttons">
          <Link to="/contact" className="btn btn-primary">
            Get A Solar Quote
          </Link>
          <Link to="/contact" className="btn btn-outline">
            Contact Selectra
          </Link>
        </div>
      </div>
    </section>
  );
}
